<template>
  <el-breadcrumb class="app-breadcrumb" separator-icon="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path + item.name">
        <span
          v-if="item.redirect === 'noRedirect' || index === levelList.length - 1"
          class="no-redirect"
        >
          {{ template(item.meta.title, item.storedParams) }}
        </span>
        <el-link
          v-else
          :underline="false"
          :to="{ name: resolve(item), params: getValidParams(item.path, item.storedParams || {}) }"
        >
          {{ template(item.meta.title, item.storedParams) }}
        </el-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-facing-decorator'
import type { RouteLocationNormalizedLoaded, _RouteRecordBase } from 'vue-router'
import { RouteNames } from '@/route-names'

@Component({ })
export default class Breadcrumb extends Vue {
  levelList: any = null
  timeout: any | null = null

  @Watch('$route', { deep: true })
  onUrlChange (route: RouteLocationNormalizedLoaded) {
    // if you go to the redirect page, do not update the breadcrumbs
    if (route.path.startsWith('/redirect/')) {
      return
    }

    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      this.getBreadcrumb()
    }, 100)
  }

  created () {
    this.getBreadcrumb()
  }

  getBreadcrumb () {
    // Capture params at this moment to avoid reactivity issues during navigation
    const currentParams = { ...this.$route.params }

    // only show routes with meta.title
    const matched: any[] = [
      {
        name: RouteNames.Root,
        path: '/',
        meta: {
          title: 'BE M&S Portal'
        },
        storedParams: {}
      }
    ]

    const routeNodes = this.$route.matched.filter(item => item.meta && item.meta.title)
    for (const route of routeNodes) {
      matched.push({
        ...route,
        storedParams: currentParams
      })
    }

    if (this.$route.meta && this.$route.meta.menuItem) {
      const resolved = this.$router.resolve({ name: this.$route.meta.menuItem })
      matched.splice(matched.length - 1, 0, {
        ...resolved,
        storedParams: currentParams
      })
    }

    if (this.$route.meta && this.$route.meta.parent) {
      const resolved = this.$router.resolve({ name: this.$route.meta.parent as string })
      matched.splice(matched.length - 1, 0, {
        ...resolved,
        storedParams: currentParams
      })
    }

    this.levelList = matched
      .filter(item => item.meta && item.meta.title)
  }

  resolve (item: _RouteRecordBase) {
    return item.redirect && typeof item.redirect === 'object' && 'name' in item.redirect
      ? item.redirect.name
      : item.name
  }

  template (text: string, storedParams?: Record<string, any>) {
    const data = storedParams || this.$route.params
    return text.replace(/{(\w*)}/g, (m, key) => data.hasOwnProperty(key) ? data[key] : '')
  }

  getValidParams (path: string, params: Record<string, any>): Record<string, any> {
    // only add params if they are in the url
    const paramNames = (path.match(/:(\w+)/g) || []).map(p => p.slice(1))
    return Object.fromEntries(
      Object.entries(params).filter(([key]) => paramNames.includes(key))
    )
  }
}
</script>
